export const LocalstorageConstants = {
  CLIENT_ID: 'clientId',
  PROVIDER: (orderId: string, recipientId: string) => `provider_${orderId}_${recipientId}`,
  SIDEBAR_EXTENDED: 'sidebarExtended',
  INVITED_EMAILS: 'invitedEmails',
  CODE_VERIFIER: (orderId: string, recipientId: string) => `code_verifier_${orderId}_${recipientId}`,
  REDIRECT_URI: 'url',
};
